import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { modalDatasource } from '../../../shared/modules/dialogOptions';
import { IncidentTypeDataSourceEditor } from './incident-type-datasource-editor.component';
@Component({
    selector: 'app-incident-type-field-setting',
    templateUrl: './incident-type-field-setting.component.html',
    styleUrls: ['./incident-type-field-setting.component.scss', '../../layout/layout.component.scss']
})
export class IncidentTypeFieldSetting {
    private _formGroup: FormGroup;
    private _subscription: Subscription;

    constructor(private modalService: NgbModal) {
        this._formGroup = new FormGroup({
            id: new FormControl(null),
            label: new FormControl(null, [Validators.required]),
            dataSource: new FormControl([]),
            excludedValues: new FormControl([]),
            value: new FormControl(null),
            required: new FormControl(false)
        });

        this.onChanged = new EventEmitter();

    }

    get form() {
        return this._formGroup;
    }

    get labelControl() {
        return this._formGroup.controls["label"];
    }

    get valueControl() {
        return this._formGroup.controls["value"];
    }

    get requiredControl() {
        return this._formGroup.controls["required"];
    }

    get dataSourceControl() {
        return this._formGroup.controls["dataSource"];
    }

    get dataSourceValue() {
        let value = "";

        if (this._formGroup.controls["dataSource"].value != null) {
            value = (this._formGroup.controls["dataSource"].value as any[]).join(",");
        }

        return value;
    }

    @Input("field-type") fieldType: string;
    @Input("field-type-flag") fieldTypeFlag: string;
    @Input("editor-type") editorType: string;

    @Input("included") included: any[] = [];
    @Input("excluded") excluded: any[] = [];

    @Input("field-setting")
    set fieldSetting(val: any) {
        this._formGroup.patchValue({
            id: val.id,
            label: val.label,
            dataSource: JSON.parse(val.dataSource),
            value: val.value,
            required: val.required
        });

        if (this._subscription) {
            this._subscription.unsubscribe();
        }

        this._subscription = this._formGroup.valueChanges.subscribe(val => {
            this.onChanged.emit(val);
        });
    }
    get fieldSetting() {
        return this._formGroup.value;
    }

    @Output() onChanged: EventEmitter<any>;

    openDataSourceEditorModal() {
        let reference = this.modalService.open(IncidentTypeDataSourceEditor, modalDatasource);
        reference.componentInstance.dataSource = this._formGroup.controls["dataSource"].value;
        reference.result.then(result => {
            this._formGroup.patchValue({
                dataSource: result
            });
        }, reason => {
            console.log("dialog cancel");
        });
    }

    triggerChange() {
        this._formGroup.patchValue({
            excludedValues: this.excluded
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/incident-types/incident-type-field-setting/incident-type-field-setting.component.ts